import type { AppProps } from "next/app";
import "nprogress/nprogress.css";

import "../styles/overrideNprogress.css";
import AssetsBaseUrlProvider from "@src/components/AssetsBaseUrlProvider";
import "@src/nextRouterEvents";
import "@src/utils/routing";
import RouterProvider from "@insightfulscience/atomic-react/utils/RouterProvider";
import { useRouter } from "next/router";

function App({ Component, pageProps }: AppProps) {
	const { push } = useRouter();

	return (
		<AssetsBaseUrlProvider>
			<RouterProvider routerPush={push}>
				<Component {...pageProps} />
			</RouterProvider>
		</AssetsBaseUrlProvider>
	);
}

export default App;
